const DashboardTypes = {
	/********************* GET DASHBOARD CARD DETAILS START ********************************* */
	GET_DASHBOARD_CARD_DETAILS_START: 'get_dashboard_card_details_start',
	GET_DASHBOARD_CARD_DETAILS_SUCCESS: 'get_dashboard_card_details_success',
	GET_DASHBOARD_CARD_DETAILS_FAILURE: 'get_dashboard_card_details_failure',
	GET_DASHBOARD_CARD_DETAILS_RESPONSE_RESET: 'get_dashboard_card_details_response_reset',
	GET_DASHBOARD_CARD_DETAILS_RESPONSE_CHANGED: 'get_dashboard_card_details_response_changed',
	/********************* GET DASHBOARD CARD DETAILS END ********************************* */

	/********************* REJECT MEMBER START ********************************* */
	REJECT_MEMBER_LIST_START: 'REJECT_MEMBER_LIST_START',
	REJECT_MEMBER_LIST_SUCCESS: 'REJECT_MEMBER_LIST_SUCCESS',
	REJECT_MEMBER_LIST_FAILURE: 'REJECT_MEMBER_LIST_FAILURE',
	REJECT_MEMBER_LIST_RESET: 'REJECT_MEMBER_LIST_RESET',
	REJECT_MEMBER_LIST_CHANGED: 'REJECT_MEMBER_LIST_CHANGED',
	/********************* REJECT MEMBER END ********************************* */

	/********************* REJECT NOTES MEMBER START ********************************* */
	REJECT_NOTES_MEMBER_LIST_START: 'REJECT_NOTES_MEMBER_LIST_START',
	REJECT_NOTES_MEMBER_LIST_SUCCESS: 'REJECT_NOTES_MEMBER_LIST_SUCCESS',
	REJECT_NOTES_MEMBER_LIST_FAILURE: 'REJECT_NOTES_MEMBER_LIST_FAILURE',
	REJECT_NOTES_MEMBER_LIST_RESET: 'REJECT_NOTES_MEMBER_LIST_RESET',
	REJECT_NOTES_MEMBER_LIST_CHANGED: 'REJECT_NOTES_MEMBER_LIST_CHANGED',
	/********************* REJECT NOTES MEMBER END ********************************* */

	/********************* GET LOAN DETAILS START ********************************* */
	GET_LOAN_DETAILS_START: 'get_loan_details_start',
	GET_LOAN_DETAILS_SUCCESS: 'get_loan_details_success',
	GET_LOAN_DETAILS_FAILURE: 'get_loan_details_failure',
	GET_LOAN_DETAILS_RESPONSE_RESET: 'get_loan_details_response_reset',
	GET_LOAN_DETAILS_RESPONSE_CHANGED: 'get_loan_details_response_changed',
	/********************* GET LOAN DETAILS END ********************************* */

	/********************* GET LOAN INDEX DETAILS START ********************************* */
	GET_LOAN_INDEX_DETAILS_START: 'get_loan_index_details_start',
	GET_LOAN_INDEX_DETAILS_SUCCESS: 'get_loan_index_details_success',
	GET_LOAN_INDEX_DETAILS_FAILURE: 'get_loan_index_details_failure',
	GET_LOAN_INDEX_DETAILS_RESPONSE_RESET: 'get_loan_index_details_response_reset',
	GET_LOAN_INDEX_DETAILS_RESPONSE_CHANGED: 'get_loan_index_details_response_changed',
	/********************* GET LOAN INDEX DETAILS END ********************************* */

	/********************* GET DASHBOARD DETAILS LOAN TYPE START ********************************* */
	GET_DASHBOARD_DETAILS_LOAN_TYPE_START: 'get_dashboard_details_loan_type_start',
	GET_DASHBOARD_DETAILS_LOAN_TYPE_SUCCESS: 'get_dashboard_details_loan_type_success',
	GET_DASHBOARD_DETAILS_LOAN_TYPE_FAILURE: 'get_dashboard_details_loan_type_failure',
	GET_DASHBOARD_DETAILS_LOAN_TYPE_RESPONSE_RESET:
		'get_dashboard_details_loan_type_response_reset',
	GET_DASHBOARD_DETAILS_LOAN_TYPE_RESPONSE_CHANGED:
		'get_dashboard_details_loan_type_response_changed',
	/********************* GET DASHBOARD DETAILS LOAN TYPE END ********************************* */

	/********************* COMPANY EOD STATUS START ********************************* */
	COMPANY_EOD_STATUS_START: 'company_eod_status_start',
	COMPANY_EOD_STATUS_SUCCESS: 'company_eod_status_success',
	COMPANY_EOD_STATUS_FAILURE: 'company_eod_status_failure',
	COMPANY_EOD_STATUS_RESPONSE_RESET: 'company_eod_status_response_reset',
	COMPANY_EOD_STATUS_RESPONSE_CHANGED: 'company_eod_status_response_changed',
	/********************* COMPANY EOD STATUS END ********************************* */

	/********************* GET DASHBOARD PARTICULAR DETAILS START ********************************* */
	GET_DASHBOARD_PARTICULAR_DETAILS_START: 'GET_DASHBOARD_PARTICULAR_DETAILS_START',
	GET_DASHBOARD_PARTICULAR_DETAILS_SUCCESS: 'GET_DASHBOARD_PARTICULAR_DETAILS_SUCCESS',
	GET_DASHBOARD_PARTICULAR_DETAILS_FAILURE: 'GET_DASHBOARD_PARTICULAR_DETAILS_FAILURE',
	GET_DASHBOARD_PARTICULAR_DETAILS_RESET: 'GET_DASHBOARD_PARTICULAR_DETAILS_RESET',
	GET_DASHBOARD_PARTICULAR_DETAILS_CHANGED: 'GET_DASHBOARD_PARTICULAR_DETAILS_CHANGED',
	/********************* GET DASHBOARD PARTICULAR DETAILS END ********************************* */

	/********************* GET DASHBOARD STAFF COLLECTION START ********************************* */
	GET_DASHBOARD_STAFF_COLLECTION_START: 'GET_DASHBOARD_STAFF_COLLECTION_START',
	GET_DASHBOARD_STAFF_COLLECTION_SUCCESS: 'GET_DASHBOARD_STAFF_COLLECTION_SUCCESS',
	GET_DASHBOARD_STAFF_COLLECTION_FAILURE: 'GET_DASHBOARD_STAFF_COLLECTION_FAILURE',
	GET_DASHBOARD_STAFF_COLLECTION_RESET: 'GET_DASHBOARD_STAFF_COLLECTION_RESET',
	GET_DASHBOARD_STAFF_COLLECTION_CHANGED: 'GET_DASHBOARD_STAFF_COLLECTION_CHANGED',
	/********************* GET DASHBOARD STAFF COLLECTION END ********************************* */

	/********************* GET STAFF LOCATION START ********************************* */
	GET_STAFF_LOCATION_START: 'GET_STAFF_LOCATION_START',
	GET_STAFF_LOCATION_SUCCESS: 'GET_STAFF_LOCATION_SUCCESS',
	GET_STAFF_LOCATION_FAILURE: 'GET_STAFF_LOCATION_FAILURE',
	GET_STAFF_LOCATION_RESET: 'GET_STAFF_LOCATION_RESET',
	GET_STAFF_LOCATION_CHANGED: 'GET_STAFF_LOCATION_CHANGED',
	/********************* GET STAFF LOCATION END ********************************* */

	/********************* DEMAND SECTION START ********************************* */
	GET_PARTICULAR_DATE_DEMAND_START: 'GET_PARTICULAR_DATE_DEMAND_START',
	GET_PARTICULAR_DATE_DEMAND_SUCCESS: 'GET_PARTICULAR_DATE_DEMAND_SUCCESS',
	GET_PARTICULAR_DATE_DEMAND_FAILURE: 'GET_PARTICULAR_DATE_DEMAND_FAILURE',
	GET_PARTICULAR_DATE_DEMAND_RESET: 'GET_PARTICULAR_DATE_DEMAND_RESET',
	GET_PARTICULAR_DATE_DEMAND_CHANGED: 'GET_PARTICULAR_DATE_DEMAND_CHANGED',

	GET_PARTICULAR_DATE_DEMAND_INFO_START: 'GET_PARTICULAR_DATE_DEMAND_INFO_START',
	GET_PARTICULAR_DATE_DEMAND_INFO_SUCCESS: 'GET_PARTICULAR_DATE_DEMAND_INFO_SUCCESS',
	GET_PARTICULAR_DATE_DEMAND_INFO_FAILURE: 'GET_PARTICULAR_DATE_DEMAND_INFO_FAILURE',
	GET_PARTICULAR_DATE_DEMAND_INFO_RESET: 'GET_PARTICULAR_DATE_DEMAND_INFO_RESET',
	GET_PARTICULAR_DATE_DEMAND_INFO_CHANGED: 'GET_PARTICULAR_DATE_DEMAND_INFO_CHANGED',

	GET_PARTICULAR_DATE_MEMBER_ABSENT_START: 'GET_PARTICULAR_DATE_MEMBER_ABSENT_START',
	GET_PARTICULAR_DATE_MEMBER_ABSENT_SUCCESS: 'GET_PARTICULAR_DATE_MEMBER_ABSENT_SUCCESS',
	GET_PARTICULAR_DATE_MEMBER_ABSENT_FAILURE: 'GET_PARTICULAR_DATE_MEMBER_ABSENT_FAILURE',
	GET_PARTICULAR_DATE_MEMBER_ABSENT_RESET: 'GET_PARTICULAR_DATE_MEMBER_ABSENT_RESET',
	GET_PARTICULAR_DATE_MEMBER_ABSENT_CHANGED: 'GET_PARTICULAR_DATE_MEMBER_ABSENT_CHANGED',
	/********************* DEMAND SECTION END ********************************* */

	/********************* COLLECTION SECTION START ********************************* */
	GET_PARTICULAR_DATE_COLLECTION_START: 'GET_PARTICULAR_DATE_COLLECTION_START',
	GET_PARTICULAR_DATE_COLLECTION_SUCCESS: 'GET_PARTICULAR_DATE_COLLECTION_SUCCESS',
	GET_PARTICULAR_DATE_COLLECTION_FAILURE: 'GET_PARTICULAR_DATE_COLLECTION_FAILURE',
	GET_PARTICULAR_DATE_COLLECTION_RESET: 'GET_PARTICULAR_DATE_COLLECTION_RESET',
	GET_PARTICULAR_DATE_COLLECTION_CHANGED: 'GET_PARTICULAR_DATE_COLLECTION_CHANGED',

	GET_PARTICULAR_DATE_COLLECTION_INFO_START: 'GET_PARTICULAR_DATE_COLLECTION_INFO_START',
	GET_PARTICULAR_DATE_COLLECTION_INFO_SUCCESS: 'GET_PARTICULAR_DATE_COLLECTION_INFO_SUCCESS',
	GET_PARTICULAR_DATE_COLLECTION_INFO_FAILURE: 'GET_PARTICULAR_DATE_COLLECTION_INFO_FAILURE',
	GET_PARTICULAR_DATE_COLLECTION_INFO_RESET: 'GET_PARTICULAR_DATE_COLLECTION_INFO_RESET',
	GET_PARTICULAR_DATE_COLLECTION_INFO_CHANGED: 'GET_PARTICULAR_DATE_COLLECTION_INFO_CHANGED',
	/********************* COLLECTION SECTION END ********************************* */

	/********************* WEEK COLLECTION SECTION START ********************************* */
	GET_WEEK_COLLECTION_START: 'GET_WEEK_COLLECTION_START',
	GET_WEEK_COLLECTION_SUCCESS: 'GET_WEEK_COLLECTION_SUCCESS',
	GET_WEEK_COLLECTION_FAILURE: 'GET_WEEK_COLLECTION_FAILURE',
	GET_WEEK_COLLECTION_RESET: 'GET_WEEK_COLLECTION_RESET',
	GET_WEEK_COLLECTION_CHANGED: 'GET_WEEK_COLLECTION_CHANGED',

	GET_WEEK_YT_COLLECTION_START: 'GET_WEEK_YT_COLLECTION_START',
	GET_WEEK_YT_COLLECTION_SUCCESS: 'GET_WEEK_YT_COLLECTION_SUCCESS',
	GET_WEEK_YT_COLLECTION_FAILURE: 'GET_WEEK_YT_COLLECTION_FAILURE',
	GET_WEEK_YT_COLLECTION_RESET: 'GET_WEEK_YT_COLLECTION_RESET',
	GET_WEEK_YT_COLLECTION_CHANGED: 'GET_WEEK_YT_COLLECTION_CHANGED',
	/********************* WEEK COLLECTION SECTION END ********************************* */

	/********************* SMS USED LIST SECTION START ********************************* */
	SMS_USED_LIST_START: 'SMS_USED_LIST_START',
	SMS_USED_LIST_SUCCESS: 'SMS_USED_LIST_SUCCESS',
	SMS_USED_LIST_FAILURE: 'SMS_USED_LIST_FAILURE',
	SMS_USED_LIST_RESET: 'SMS_USED_LIST_RESET',
	SMS_USED_LIST_CHANGED: 'SMS_USED_LIST_CHANGED',
	/********************* SMS USED LIST SECTION END ********************************* */

	/********************* KYC USED LIST SECTION START ********************************* */
	KYC_USED_LIST_START: 'KYC_USED_LIST_START',
	KYC_USED_LIST_SUCCESS: 'KYC_USED_LIST_SUCCESS',
	KYC_USED_LIST_FAILURE: 'KYC_USED_LIST_FAILURE',
	KYC_USED_LIST_RESET: 'KYC_USED_LIST_RESET',
	KYC_USED_LIST_CHANGED: 'KYC_USED_LIST_CHANGED',
	/********************* KYC USED LIST SECTION END ********************************* */

	/********************* ARREAR COLLECTION LIST SECTION START ********************************* */
	ARREAR_COLLECTION_LIST_START: 'ARREAR_COLLECTION_LIST_START',
	ARREAR_COLLECTION_LIST_SUCCESS: 'ARREAR_COLLECTION_LIST_SUCCESS',
	ARREAR_COLLECTION_LIST_FAILURE: 'ARREAR_COLLECTION_LIST_FAILURE',
	ARREAR_COLLECTION_LIST_RESET: 'ARREAR_COLLECTION_LIST_RESET',
	ARREAR_COLLECTION_LIST_CHANGED: 'ARREAR_COLLECTION_LIST_CHANGED',
	/********************* ARREAR COLLECTION LIST SECTION END ********************************* */

	/********************* DASHBOARD STAFF MAP COLLECTION START ********************************* */
	DASHBOARD_STAFF_MAP_COLLECTION_START: 'DASHBOARD_STAFF_MAP_COLLECTION_START',
	DASHBOARD_STAFF_MAP_COLLECTION_SUCCESS: 'DASHBOARD_STAFF_MAP_COLLECTION_SUCCESS',
	DASHBOARD_STAFF_MAP_COLLECTION_FAILURE: 'DASHBOARD_STAFF_MAP_COLLECTION_FAILURE',
	DASHBOARD_STAFF_MAP_COLLECTION_RESET: 'DASHBOARD_STAFF_MAP_COLLECTION_RESET',
	DASHBOARD_STAFF_MAP_COLLECTION_CHANGED: 'DASHBOARD_STAFF_MAP_COLLECTION_CHANGED',
	/********************* DASHBOARD STAFF MAP COLLECTION END ********************************* */

	/********************* DASHBOARD COLLECTION NOTE INFO START ********************************* */
	DASHBOARD_COLLECTION_NOTE_INFO_START: 'DASHBOARD_COLLECTION_NOTE_INFO_START',
	DASHBOARD_COLLECTION_NOTE_INFO_SUCCESS: 'DASHBOARD_COLLECTION_NOTE_INFO_SUCCESS',
	DASHBOARD_COLLECTION_NOTE_INFO_FAILURE: 'DASHBOARD_COLLECTION_NOTE_INFO_FAILURE',
	DASHBOARD_COLLECTION_NOTE_INFO_RESET: 'DASHBOARD_COLLECTION_NOTE_INFO_RESET',
	DASHBOARD_COLLECTION_NOTE_INFO_CHANGED: 'DASHBOARD_COLLECTION_NOTE_INFO_CHANGED',
	/********************* DASHBOARD COLLECTION NOTE INFO END ********************************* */

	/***************** Get Dashboard Savind And FD Details *******************/
	GET_DASHBOARD_SAVINGS_FD_START: 'get_dashboard_savings_fd_start',
	GET_DASHBOARD_SAVINGS_FD_SUCCESS: 'get_dashboard_savings_fd_success',
	GET_DASHBOARD_SAVINGS_FD_FAILURE: 'get_dashboard_savings_fd_failure',
	GET_DASHBOARD_SAVINGS_FD_RESET: 'get_dashboard_savings_fd_reset',
	GET_DASHBOARD_SAVINGS_FD_CHANGED: 'get_dashboard_savings_fd_changed',
	/*********** Get Dashboard Savind And FD Details ***************/

	/*********** Get Dashboard Total Branch Member ***************/
	GET_DASHBOARD_TOTAL_BRANCH_MEMBER_START: 'get_dashboard_total_branch_member_start',
	GET_DASHBOARD_TOTAL_BRANCH_MEMBER_SUCCESS: 'get_dashboard_total_branch_member_success',
	GET_DASHBOARD_TOTAL_BRANCH_MEMBER_FAILURE: 'get_dashboard_total_branch_member_failure',
	GET_DASHBOARD_TOTAL_BRANCH_MEMBER_RESET: 'get_dashboard_total_branch_member_reset',
	GET_DASHBOARD_TOTAL_BRANCH_MEMBER_CHANGED: 'get_dashboard_total_branch_member_changed',
	/*********** Get Dashboard Total Branch Member ***************/

	/*********** Get Branch Total Investment Amount ***************/
	GET_BRANCH_TOTAL_INVESTMENT_AMOUNT_START: 'get_branch_total_investment_amount_start',
	GET_BRANCH_TOTAL_INVESTMENT_AMOUNT_SUCCESS: 'get_branch_total_investment_amount_success',
	GET_BRANCH_TOTAL_INVESTMENT_AMOUNT_FAILURE: 'get_branch_total_investment_amount_failure',
	GET_BRANCH_TOTAL_INVESTMENT_AMOUNT_RESET: 'get_branch_total_investment_amount_reset',
	GET_BRANCH_TOTAL_INVESTMENT_AMOUNT_CHANGED: 'get_branch_total_investment_amount_changed',
	/*********** Get Branch Total Investment Amount ***************/

	/*********** Get Branch Total OLB Amount ***************/
	GET_BRANCH_TOTAL_OLB_AMOUNT_START: 'get_branch_total_olb_amount_start',
	GET_BRANCH_TOTAL_OLB_AMOUNT_SUCCESS: 'get_branch_total_olb_amount_success',
	GET_BRANCH_TOTAL_OLB_AMOUNT_FAILURE: 'get_branch_total_olb_amount_failure',
	GET_BRANCH_TOTAL_OLB_AMOUNT_RESET: 'get_branch_total_olb_amount_reset',
	GET_BRANCH_TOTAL_OLB_AMOUNT_CHANGED: 'get_branch_total_olb_amount_changed',
	/*********** Get Branch Total OLB Amount ***************/

	/*********** Get Total Collection ***************/
	GET_TOTAL_COLLECTION_START: 'get_total_collection_start',
	GET_TOTAL_COLLECTION_SUCCESS: 'get_total_collection_success',
	GET_TOTAL_COLLECTION_FAILURE: 'get_total_collection_failure',
	GET_TOTAL_COLLECTION_RESET: 'get_total_collection_reset',
	GET_TOTAL_COLLECTION_CHANGED: 'get_total_collection_changed',
	/*********** Get Total Collection ***************/

	/*********** Get Dashboard Amount Based on Location ***************/
	GET_DASHBOARD_AMOUNT_BASED_ON_LOCATION_START: 'get_dashboard_amount_based_on_location_start',
	GET_DASHBOARD_AMOUNT_BASED_ON_LOCATION_SUCCESS:
		'get_dashboard_amount_based_on_location_success',
	GET_DASHBOARD_AMOUNT_BASED_ON_LOCATION_FAILURE:
		'get_dashboard_amount_based_on_location_failure',
	GET_DASHBOARD_AMOUNT_BASED_ON_LOCATION_RESET: 'get_dashboard_amount_based_on_location_reset',
	GET_DASHBOARD_AMOUNT_BASED_ON_LOCATION_CHANGED:
		'get_dashboard_amount_based_on_location_changed',
	/*********** Get Dashboard Amount Based on Location ***************/

	/*********** Get Dashboard Zero Collection Details ***************/
	GET_DASHBOARD_ZERO_COLLECTION_DETAILS_START: 'get_dashboard_zero_collection_details_start',
	GET_DASHBOARD_ZERO_COLLECTION_DETAILS_SUCCESS: 'get_dashboard_zero_collection_details_success',
	GET_DASHBOARD_ZERO_COLLECTION_DETAILS_FAILURE: 'get_dashboard_zero_collection_details_failure',
	GET_DASHBOARD_ZERO_COLLECTION_DETAILS_RESET: 'get_dashboard_zero_collection_details_reset',
	GET_DASHBOARD_ZERO_COLLECTION_DETAILS_CHANGED: 'get_dashboard_zero_collection_details_changed',
	/*********** Get Dashboard Zero Collection Details ***************/

	/*********** Get Online Staff Details ***************/
	GET_ONLINE_STAFF_DETAILS_START: 'get_online_staff_details_start',
	GET_ONLINE_STAFF_DETAILS_SUCCESS: 'get_online_staff_details_success',
	GET_ONLINE_STAFF_DETAILS_FAILURE: 'get_online_staff_details_failure',
	GET_ONLINE_STAFF_DETAILS_RESET: 'get_online_staff_details_reset',
	GET_ONLINE_STAFF_DETAILS_CHANGED: 'get_online_staff_details_changed',
	/*********** Get Online Staff Details ***************/

	/*********** Get Officer Live Status ***************/
	GET_OFFICER_LIVE_STATUS_START: 'get_officer_live_status_start',
	GET_OFFICER_LIVE_STATUS_SUCCESS: 'get_officer_live_status_success',
	GET_OFFICER_LIVE_STATUS_FAILURE: 'get_officer_live_status_failure',
	GET_OFFICER_LIVE_STATUS_RESET: 'get_officer_live_status_reset',
	GET_OFFICER_LIVE_STATUS_CHANGED: 'get_officer_live_status_changed',
	/*********** Get Officer Live Status ***************/

	/*********** Get Gold Loan Card Details ***************/
	GET_GOLD_LOAN_CARD_DETAILS_START: 'get_gold_loan_card_details_start',
	GET_GOLD_LOAN_CARD_DETAILS_SUCCESS: 'get_gold_loan_card_details_success',
	GET_GOLD_LOAN_CARD_DETAILS_FAILURE: 'get_gold_loan_card_details_failure',
	GET_GOLD_LOAN_CARD_DETAILS_RESPONSE_RESET: 'get_gold_loan_card_details_response_reset',
	GET_GOLD_LOAN_CARD_DETAILS_RESPONSE_CHANGED: 'get_gold_loan_card_details_response_changed',
	/*********** Get Gold Loan Card Details ***************/

	/*********** Get Gold Loan Dashboard Loan Details ***************/
	GET_GOLD_LOAN_DASHBOARD_LOAN_DETAILS_START: 'get_gold_loan_dashboard_loan_details_start',
	GET_GOLD_LOAN_DASHBOARD_LOAN_DETAILS_SUCCESS: 'get_gold_loan_dashboard_loan_details_success',
	GET_GOLD_LOAN_DASHBOARD_LOAN_DETAILS_FAILURE: 'get_gold_loan_dashboard_loan_details_failure',
	GET_GOLD_LOAN_DASHBOARD_LOAN_DETAILS_RESPONSE_RESET:
		'get_gold_loan_dashboard_loan_details_response_reset',
	GET_GOLD_LOAN_DASHBOARD_LOAN_DETAILS_RESPONSE_CHANGED:
		'get_gold_loan_dashboard_loan_details_response_changed',
	/*********** Get Gold Loan Dashboard Loan Details ***************/

	/*********** Get Gold Loan Loan Index Details ***************/
	GET_GOLD_LOAN_LOAN_INDEX_DETAILS_START: 'get_gold_loan_loan_index_details_start',
	GET_GOLD_LOAN_LOAN_INDEX_DETAILS_SUCCESS: 'get_gold_loan_loan_index_details_success',
	GET_GOLD_LOAN_LOAN_INDEX_DETAILS_FAILURE: 'get_gold_loan_loan_index_details_failure',
	GET_GOLD_LOAN_LOAN_INDEX_DETAILS_RESPONSE_RESET:
		'get_gold_loan_loan_index_details_response_reset',
	GET_GOLD_LOAN_LOAN_INDEX_DETAILS_RESPONSE_CHANGED:
		'get_gold_loan_loan_index_details_response_changed',
	/*********** Get Gold Loan Loan Index Details ***************/
};

export default DashboardTypes;
